<ng-container [formGroup]="form">
	<tvcore-select key="type" name="subsidyType" [options]="subsidyTypes">
		<ng-template #optionTemplate let-option>
			{{ option.name }}
		</ng-template>
	</tvcore-select>
</ng-container>
